import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../constants/documentTheme';
import { SellerFooterLines } from './SellerDisclosures';

const PartnerWorkspaceFooter = ({
  supportHref = 'mailto:partners@dejavunomad.com',
  links,
  testId = 'partner-workspace-footer',
  sx = {},
}) => {
  const { t } = useTranslation();
  const items = links || [
    { href: '/partner-terms', label: t('partnerDash.partnerAgreement') },
    { href: '/privacy', label: t('partnerDash.privacy') },
    { href: '/partner', label: t('partnerDash.partnerGuide') },
    { href: supportHref, label: t('partnerDash.contactSupport') },
  ];

  return (
    <Box
      component="footer"
      data-testid={testId}
      sx={{
        mt: 5.5,
        borderTop: `1px solid ${DOCUMENT.ruleHard}`,
        pt: 2.5,
        display: 'flex',
        gap: '12px 24px',
        flexWrap: 'wrap',
        alignItems: 'center',
        ...sx,
      }}
    >
      {items.map((item) => (
        <Typography
          key={item.href}
          component="a"
          href={item.href}
          sx={{ fontSize: 11.5, color: DOCUMENT.ink2, textDecoration: 'none', '&:hover': { color: DOCUMENT.ink } }}
        >
          {item.label}
        </Typography>
      ))}
      <Typography
        sx={{
          ml: { sm: 'auto' },
          width: { xs: '100%', sm: 'auto' },
          fontSize: 11.5,
          color: DOCUMENT.ink3,
          letterSpacing: '0.06em',
          textAlign: { sm: 'right' },
        }}
      >
        {t('trip.poweredBy')}
      </Typography>
      <SellerFooterLines sx={{ width: '100%' }} />
    </Box>
  );
};

export default PartnerWorkspaceFooter;
